export default "__VITE_ASSET__WcBeL2HQ__"